// extracted by mini-css-extract-plugin
export var label = "_fi-2";
export var slideContainer = "_fi-0";
export var slider = "_fi-1";